import React, {useEffect, useState} from 'react';
import './StockList.scss'
import {gql, useLazyQuery} from "@apollo/client";
import Loader from "../Loader/Loader";
import {useParams} from "react-router-dom";
import StockListCard from "./partials/StockListCard";
import IndexListCard from "./partials/IndexListCard";
import CryptoListCard from "./partials/CryptoListCard";

const StockList = ({searchText, searchSector, scrollLock, setScrollLock, isIndexListScreen, isCryptoListScreen}) => {
    const [fetchedStockList, setFetchedStockList] = useState()
    const [hasNextPage, setHasNextPage] = useState(false)
    const first = 10
    const {countryName} = useParams()
    let query
    let queryVariables

    const QUERY_ALL_STOCKS = gql`
        query getAllStock($first: Int, $after: String, $searchText: String, $country: String,  $sector: String) {
            allStocks (first: $first, after: $after, searchText: $searchText, country: $country, sector: $sector){
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    cursor
                    node {
                        profileId {
                            ticker
                            dayLow
                            dayHigh
                            currentPrice
                            changeLastDay
                            changePercentageLastDay
                            currency
                            country
                            priceChangeDateTime
                            swedishIndex {
                                fullName
                            }
                        }
                        id
                        fullName
                        slug
                        currency
                    }
                }
            }}`

    const QUERY_ALL_INDICES = gql`
        query indexesPricesInternal($first: Int, $after: String,  $searchText: String) {
            indexesPricesInternal (first: $first, after: $after, searchText: $searchText){
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    cursor
                    node {
                        swedishIndex {
                            indexCustomName
                            country
                            slug
                        }
                        indexId
                        currentPrice
                        highPrice
                        lowPrice
                        changeLastDay
                        changePercentageLastDay
                    }
                }
            }}`


    const QUERY_ALL_CRYPTO = gql`
        query cryptoPricesInternal($first: Int, $after: String,  $searchText: String) {
            cryptoPricesInternal (first: $first, after: $after, searchText: $searchText){
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
                edges {
                    cursor
                    node {
                        cryptoId
                        {
                            customName
                            symbol
                            slug
                        }
                        currentPrice
                        dayHigh
                        dayLow
                        changeLastDay
                        changePercentageLastDay
                    }
                }
            }}`



// Polling: provides near-real-time synchronization with
    // your server by causing a query to execute periodically
    // at a specified interval


    switch (true) {
        case (isIndexListScreen): {
            queryVariables = {
                after: null,
                first: first,
                searchText: searchText,
                sector: searchSector,
            }
            break;
        }
        case (isCryptoListScreen): {
            queryVariables = {
                after: null,
                first: first,
                searchText: searchText,
            }
            break;
        }
        default: {
            queryVariables = {
                after: null,
                first: first,
                country: countryName,
                searchText: searchText,
                sector: searchSector,
            }
        }
    }

    switch (true) {
        case (isIndexListScreen): {
            query = QUERY_ALL_INDICES
            break;
        }
        case (isCryptoListScreen): {
            query = QUERY_ALL_CRYPTO
            break;
        }
        default: {
            query = QUERY_ALL_STOCKS
        }
    }

    const onQueryCompleted = (data) => {
        if (isIndexListScreen) {
            setFetchedStockList(data.indexesPricesInternal.edges)
            setHasNextPage(data.indexesPricesInternal.pageInfo.hasNextPage)
            if (data.indexesPricesInternal.pageInfo.hasNextPage === false) {
                setScrollLock(true)
            }
        } else if (isCryptoListScreen) {
            setFetchedStockList(data.cryptoPricesInternal.edges)
            setHasNextPage(data.cryptoPricesInternal.pageInfo.hasNextPage)
            if (data.cryptoPricesInternal.pageInfo.hasNextPage === false) {
                setScrollLock(true)
            }
        } else {
            setFetchedStockList(data.allStocks.edges)
            setHasNextPage(data.allStocks.pageInfo.hasNextPage)
            if (data.allStocks.pageInfo.hasNextPage === false) {
                setScrollLock(true)
            }
        }
    }

    const [queryAllStocks, {data, loading, error, fetchMore}] = useLazyQuery(
        query, {
            variables: queryVariables,
            fetchPolicy: 'network-only',
            //pollInterval: 5000,
            onCompleted: (data) => {
                onQueryCompleted(data)
            }
        }
    );

    useEffect(() => {
        queryAllStocks()
        if (!searchText) {
            setScrollLock(false)

        }
    }, [searchText, queryAllStocks, setScrollLock])

    const getMoreStocks = () => {
        const {endCursor} = isIndexListScreen ? data.indexesPricesInternal.pageInfo : data.allStocks.pageInfo
        //  setendCursor(data.allStocks.pageInfo.endCursor)
        fetchMore(isIndexListScreen ? {
            variables: {after: endCursor},
            updateQuery: (previousResult, {fetchMoreResult}) => {
                fetchMoreResult.indexesPricesInternal.edges = [
                    ...previousResult.indexesPricesInternal.edges,
                    ...fetchMoreResult.indexesPricesInternal.edges,
                ]
                return fetchMoreResult;
            }
        } : {
            variables: {after: endCursor},
            updateQuery: (previousResult, {fetchMoreResult}) => {
                fetchMoreResult.allStocks.edges = [
                    ...previousResult.allStocks.edges,
                    ...fetchMoreResult.allStocks.edges,
                ]
                return fetchMoreResult;
            }
        })


    }
    // should handle loading status
    if (loading || error) return <Loader/>


    return (
        <>

            {isIndexListScreen ?
                <IndexListCard fetchedStockList={fetchedStockList} hasNextPage={hasNextPage} scrollLock={scrollLock}
                               getMoreStocks={getMoreStocks}/> : isCryptoListScreen ?
                    <CryptoListCard fetchedStockList={fetchedStockList} hasNextPage={hasNextPage}
                                    scrollLock={scrollLock}
                                    getMoreStocks={getMoreStocks}/> :
                    <StockListCard fetchedStockList={fetchedStockList} hasNextPage={hasNextPage} scrollLock={scrollLock}
                                   getMoreStocks={getMoreStocks}/>}

        </>

    )
}

export default StockList;